import React, { useMemo, useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { showModal } from '../../actions/modal';
import Banners from './Banners/Banners';

import { fetchGetUnreadedTicketCount } from '../../actions/tickets';
import { checkRouteAccessibility } from '../../helpers/privileges';
import { getCurrencySymbol, isNegative, getPositiveSum } from '../../helpers';
import { fetchToggleAdminPanel, logout, toggleAdminPanel } from '../../actions/auth';
import useOnclickOutside from 'react-cool-onclickoutside';

import logoImg from '../../assets/images/kak2c_logo.svg';
import logoImgEng from '../../assets/images/kak2c_logo_english.svg';

import numeral from 'numeral';
import moment from 'moment';
import Toogle from '../common/Toogle';
import LocaleSwitcher from '../Language/LocaleSwitcher';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const WarningMessage = styled('div')`
  position: absolute;
  width: 100%;
  height: 30px;
  background-color: #f7b84b;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: -20px;
  font-size: 14px;
  @media (max-width: 600px) {
    bottom: -26px;
  }
`;

const Wrapper = styled('div')`
  .mobile-menu-burger {
    display: none;
  }

  .nav-link.question-link {
    font-size: 14px;
    color: #7e57c3;
    position: relative;
    display: flex;
    align-items: center;

    &:after {
      content: '';
      position: absolute;
      top: 20px;
      bottom: 20px;
      right: 0;
      border-right: 1px solid #d1dce1;
    }

    .mdi-forum {
      font-size: 19px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .unreaded-count {
      height: 16px;
      min-width: 16px;
      background-color: red;
      border-radius: 18px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      line-height: 1;
      font-size: 10px;
      font-weight: bold;
      margin-left: 10px;
    }
  }

  .nav-link.user-link {
    font-size: 14px;
    background: white;
    border: transparent;
    transition: 0.3s;

    &:hover {
      background: #7e57c310;
    }

    &:active {
      background: #7e57c320;
    }

    .arrow {
      margin-left: 7px;
    }
  }
  .debt-block {
    height: 70px;
    position: relative;
    .nav-link {
      height: 95%;
    }
  }

  .neg {
    color: #f1556c !important;
    font-weight: 700;
  }
  .pos {
    color: #1aae67;
    font-weight: 700;
  }

  .debt-block__top {
    line-height: normal;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-weight: 500;
    color: #98a6ad;
    .red {
      font-size: 18px;
    }
  }
  .header-dropdown-menu.debt-menu {
    margin: 0;
    padding: 20px;
    line-height: normal;
    width: 306px;
    right: 0;
    bottom: -178px;
    p {
      margin: 0;
      font-size: 18px;
      color: #323a46;
      &.red {
        color: #f1556c;
      }
    }
    ul {
      margin: 0;
      padding: 0;
    }
    .debt-menu__item:last-child {
      padding-top: 24px;
      border-top: 1px solid #e3e3e3;
      margin-top: 24px;
    }
  }

  .header-dropdown-menu {
    position: absolute;
    background: white;
    padding: 0.3rem;
    box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.16), 0 2px 6px 0 rgba(0, 0, 0, 0.12);
    border-radius: 0.25rem;
    list-style: none;
    transition: 0.3s;
    width: 206px;
    padding: 0.3rem;
    transform: translateY(0);
    opacity: 1;
    top: 70px;

    .link {
      font-size: 14px;
      transition: 0.3s;
      padding: 7px 20px;
      background-color: #ffffff;
      display: block;
      color: #7b7e7f;
      border: none;
      width: 100%;
      text-align: left;

      &:hover {
        background: #7e57c310;
      }

      &:active {
        background: #7e57c320;
      }
    }

    &.hidden {
      opacity: 0;
      transform: translateY(10px);
      pointer-events: none;
    }

    .list {
      cursor: pointer;
    }
  }

  @media (max-width: 1024px) {
    .logo-lg {
      display: none !important;
    }

    .mobile-menu-burger {
      display: block;

      &.short {
        position: relative;
        bottom: 17px;
        left: -3px;
        height: 35px;
      }
    }
    .logo-box {
      position: absolute;
      left: 70px;
    }
    .button-menu-mobile {
      margin-top: -5px;
    }
  }

  @media (max-width: 960px) {
    height: auto;
    min-height: 35px;
    border-bottom: 1px solid #ebebeb;

    .logo-lg {
      display: block !important;
    }

    .adaptive {
      display: none;
    }

    .nav-item {
      position: relative;
    }

    .header-dropdown-menu {
      right: 0;
    }

    .nav-help {
      height: 70px;
    }

    .button-menu-mobile {
      margin-top: 0;
    }
  }

  @media (max-width: 550px) {
    ul.float-right {
      display: none;
    }
    .button-menu-mobile {
      margin-top: 0;
    }
  }

  .headerBanners {
    top: 0;
    bottom: 0;
    margin: auto 0;
    display: flex;
    align-items: center;
    left: 240px;
    img {
      max-width: 515px;
    }
  }

  @media (max-width: 1440px) {
    .headerBanners {
      img {
        max-width: 380px;
      }
    }
  }

  @media (max-width: 1199px) {
    .headerBanners {
      display: none;
    }
  }

  .headerBanner {
    position: absolute;
    button {
      position: absolute;
      top: 0;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 15px;
      background: #fff;
      width: 20px;
      height: 20px;
      border-radius: 2px;
    }
  }

  .admin-toggle {
    font-size: 13px;
    padding: 0 20px;
  }

  .header-right-panel {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .admin-shield {
    margin-left: auto;
    max-width: 240px;
    background-color: #f245d6;
    color: white;
    padding: 0 16px;
    border-radius: 4px;
  }

  .header-info-panel {
    margin-left: auto;
    display: flex;
  }

  @media (max-width: 767px) {
    .header-info-panel {
      display: none;
    }

    .logo-box--centered {
      display: block;
      position: absolute;
      width: 100%;
      height: auto;
      left: auto;
      img {
        position: absolute;
        width: 64px;
        height: 23px;
        object-fit: contain;
        left: 0;
        right: 0;
        margin: auto;
        top: -2px;
      }
    }
  }

  .legal-info {
    min-width: 160px;
    max-width: 600px;
  }

  .menu-button {
    display: flex;
    padding: 10px 0 10px 10px;
    cursor: pointer;
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-left: 5px;
  }

  .mdi-account-circle {
    font-size: 35px;
  }

  .admin-toggle {
    color: #f245d6;
    font-weight: 700;
    padding: 15px 0 8px 20px;
  }

  .login {
    max-height: 70px;
  }

  .locale-switcher-wrap {
    height: 100%;
  }

  .logo-img-eng {
    height: 36px !important;
  }
`;

const Header = (props) => {
  const { customHeader, mobileCustomMenu, handleBurgerClick, auth } = props;
  const { account, privileges } = auth;
  const [adminPanel, setAdminPanel] = useState(false);
  const admin = localStorage.getItem('admin');

  const { t, i18n } = useAutoTranslation();

  useEffect(() => {
    dispatch(fetchGetUnreadedTicketCount());
  }, []);

  const handleChange = (value) => {
    dispatch(fetchToggleAdminPanel(value));
    setAdminPanel(value);
  };

  useEffect(() => {
    const adminMode = localStorage.getItem('adminPanel');
    if (adminMode === 'true') {
      setAdminPanel(true);
    } else {
      setAdminPanel(false);
    }
  }, []);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showDebt, setShowDebt] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);

  const { unreadedCount } = useSelector((state) => state.tickets);
  const { organizationSettings } = useSelector((state) => state.settings);

  const dispatch = useDispatch();

  const handleQuestionClick = (e) => {
    //ToDo временный код для скрытия на продакшне функционала тикетов
    /*if (DOMAIN === 'app-test.kak2c.ru' || e.shiftKey){*/
    e.preventDefault();
    e.stopPropagation();

    //ToDo постоянный код
    dispatch(showModal('TicketList', {}));
    /*}*/
  };

  const getDept = (balance) => {
    return balance < 0 ? getPositiveSum(balance) : '0,00';
  };

  const handleSetNewAccountingAttribute = () => {
    dispatch(showModal('ChangeUserPassword', {}));
    setTimeout(() => setShowDropdown(false), 200);
  };

  const ref = useOnclickOutside(() => {
    setShowDropdown(false);
  });

  const debtRef = useOnclickOutside(() => {
    setShowDebt(false);
  });

  return useMemo(
    () => (
      <Wrapper className="navbar-custom navbar-custom-light">
        <div className="logo-box logo-box--centered">
          <Link to="/" className="logo text-center">
            {i18n.language === 'cn' ? (
              <>
                <span className="logo-lg">
                  <img src={logoImgEng} className="logo-img-eng" alt="Kak2c logo" height="50" />
                </span>
                <span className="logo-sm">
                  <img src={logoImgEng} className="logo-img-eng" alt="Kak2c logo" height="50" />
                </span>
              </>
            ) : (
              <>
                <span className="logo-lg">
                  <img src={logoImg} alt="Kak2c logo" height="50" />
                </span>
                <span className="logo-sm">
                  <img src={logoImg} alt="Kak2c logo" height="50" />
                </span>
              </>
            )}
          </Link>
        </div>

        {customHeader ? (
          customHeader
        ) : (
          <div className="header-right-panel">
            {/* <Banners></Banners> */}
            <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
              <li className="mobile-menu-burger short">
                <button
                  className="button-menu-mobile waves-effect waves-light"
                  onClick={handleBurgerClick}
                >
                  <i className="fe-menu"></i>
                </button>
              </li>
            </ul>

            <ul className="list-unstyled topnav-menu mb-0 header-info-panel d-flex align-items-center">
              <li className="nav-item debt-block locale-switcher-wrap">
                <LocaleSwitcher />
              </li>
              {account.displayFinance && (
                <li className="nav-item debt-block" ref={debtRef}>
                  <button
                    className="nav-link user-link d-flex align-items-center lin"
                    onClick={() => setShowDebt(!showDebt)}
                  >
                    <div className="debt-block__top">
                      <div>{t('Баланс')}</div>
                      <div className={isNegative(account.billingBalance?.total)}>{`${numeral(
                        account.billingBalance?.total,
                      ).format('0,0.00')} ${getCurrencySymbol('RUB')}`}</div>
                    </div>
                    <i className="fe-chevron-down arrow" />
                  </button>
                  <ul className={`header-dropdown-menu debt-menu ${showDebt ? `` : `hidden`}`}>
                    <li className="debt-menu__item">
                      <ul>
                        <li className="row mb-2">
                          <div className="col-6">
                            <p>{t('Задолженность')}</p>
                            <span className="text-muted">
                              {t('на')} {moment(new Date()).format('DD.MM.YYYY')}
                            </span>
                          </div>
                          <div className="col-6">
                            <p className="text-right font-weight-bolder">{`${getDept(
                              account.billingBalance?.total,
                            )} ${getCurrencySymbol('RUB')}`}</p>
                          </div>
                        </li>
                        <li className="row">
                          <div className="col-6">
                            <p className="font-16">{t('Просроченная')}</p>
                          </div>
                          <div className="col-6">
                            <p className="text-right font-16 red">{`${getPositiveSum(
                              account.billingBalance?.expired,
                            )} ${getCurrencySymbol('RUB')}`}</p>
                          </div>
                        </li>
                      </ul>
                    </li>
                    <li className="debt-menu__item">
                      <Link to="/finances">{t('Перейти к платежам и документам')}</Link>
                    </li>
                  </ul>
                </li>
              )}
              <li className="nav-item" style={{}}>
                <a
                  href="https://wiki.kak2c.ru/books/instruktsiya-kaktusa"
                  target="_blank"
                  className="nav-link question-link without-border nav-help"
                >
                  <i className="fe-file-text mdi-forum reference-icon" />{' '}
                  <span className="adaptive">{t('Справка')}</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="javascript:void(0);"
                  className="nav-link question-link"
                  onClick={handleQuestionClick}
                >
                  <i className="mdi mdi-forum" />
                  <span className="adaptive">{t('Задать вопрос')}</span>
                  {unreadedCount ? <span className="unreaded-count">{unreadedCount}</span> : null}
                </a>
              </li>

              <li className="nav-item menu-item" ref={ref}>
                <div className="menu-button" onClick={() => setShowDropdown(!showDropdown)}>
                  <i className="mdi mdi-account-circle" />
                  <div className="info-wrapper">
                    <span className="adaptive login">
                      {account.login}
                      <i className="fe-chevron-down arrow" />
                    </span>
                    {account?.shopName ? (
                      <span className="adaptive legal-info">{account.shopName}</span>
                    ) : null}
                  </div>
                </div>
                <ul className={`header-dropdown-menu ${showDropdown ? `` : `hidden`}`}>
                  {checkRouteAccessibility(privileges, 'settings') ? (
                    <>
                      {admin === 'true' && (
                        <>
                          <li className="admin-point">
                            <Toogle
                              className="admin-toggle"
                              id="adminPanel"
                              onChange={(e) => handleChange(e.target.checked)}
                              label={t('Админ-режим')}
                              checked={adminPanel}
                            />
                          </li>
                          {account?.activityDisabled && adminPanel ? (
                            <li className="link list neg">{t('Активность аккаунта выключена')}</li>
                          ) : null}
                        </>
                      )}
                      <li>
                        <Link to="/settings" className="link">
                          {t('Мой профиль')}
                        </Link>
                      </li>
                      <li className="link list" onClick={handleSetNewAccountingAttribute}>
                        {t('Изменить пароль')}
                      </li>
                    </>
                  ) : null}
                  <li>
                    <button onClick={logout} className="link">
                      {t('Выход')}
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        )}
        {mobileCustomMenu ? mobileCustomMenu : null}
        {account && account.tempBlockAccount ? (
          <WarningMessage>
            {t('Аккаунт временно заблокирован')}.{' '}
            {account.tempBlockAccountReason ? account.tempBlockAccountReason : null}
          </WarningMessage>
        ) : null}
      </Wrapper>
    ),
    [
      privileges,
      customHeader,
      mobileCustomMenu,
      showDropdown,
      unreadedCount,
      showDebt,
      adminPanel,
      t,
    ],
  );
};

export default Header;
